import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

type Props = {
	goal: string;
};

export const SprintGoal = ({ goal }: Props) => (
	<Tooltip content={goal} position="bottom-end">
		{(tooltipProps) => (
			<SprintGoalContent tabIndex={0} aria-label={goal} {...tooltipProps}>
				{goal}
			</SprintGoalContent>
		)}
	</Tooltip>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SprintGoalContent = styled.div({
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	color: token('color.text.subtlest', 'rgb(98, 111, 134)'),
	fontWeight: 'normal',
	fontSize: '12px',
	lineHeight: '16px',
	marginTop: token('space.025', '2px'),
	marginBottom: token('space.025', '2px'),
	width: 'fit-content',
	maxWidth: '100%',
});
